import styled from 'styled-components';

import {Button} from '@edna/components';
import {mixins} from '@edna/components/styles';

export const Section = styled.section`
  margin-bottom: ${({theme}) => theme.spacing.s5};
`;

export const ManagerName = styled.div`
  ${mixins.flexAlign('normal', 'center')}
  ${mixins.f4}
  margin-top: ${({theme}) => theme.spacing.s1};
`;

export const EditButton = styled(Button).attrs({
  square: true,
  appearance: 'tertiary',
  size: 'S',
})`
  margin-left: ${({theme}) => theme.spacing.s2};
`;
